// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__31y_R","right":"Footer_right__z9_GF","buttons":"Footer_buttons__2EC-c"};